.bj{flex:1;}